import React from 'react'

import * as S from './section.styled'

export interface SectionProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> {
  children?: React.ReactNode
}

export const Section = ({ children, ...rest }: SectionProps) => {
  return <S.Section {...rest}>{children}</S.Section>
}
